import { forwardRef, Ref, SVGProps } from 'react'

const _IconWhimstayRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.600098" width="24" height="24" rx="6" fill="#0F7081" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.47482 8.69688C4.64071 8.42032 4.9469 8.25 5.27821 8.25H8.06256C8.57515 8.25 8.99068 8.65072 8.99068 9.14504C8.99068 9.63935 8.57515 10.0401 8.06256 10.0401H6.88272L9.5812 14.5645C9.66267 14.7011 9.86866 14.6965 9.9434 14.5563L11.7747 11.1225C11.9326 10.8264 12.2478 10.6393 12.5931 10.6368C12.9383 10.6343 13.2565 10.8168 13.419 11.1106L15.3513 14.6046C15.4272 14.7419 15.6298 14.7458 15.7113 14.6115L19.1207 8.99142C19.3796 8.56476 19.9481 8.42123 20.3905 8.67084C20.8329 8.92045 20.9818 9.46868 20.7229 9.89534L17.3135 15.5154C16.4988 16.8583 14.4727 16.8198 13.7134 15.447L12.615 13.4608L11.5941 15.375C10.8468 16.7764 8.78685 16.823 7.97213 15.457L4.47368 9.59128C4.3085 9.31432 4.30893 8.97345 4.47482 8.69688Z"
      fill="white"
    />
  </svg>
)

export const IconWhimstayRectangle = forwardRef(_IconWhimstayRectangle)
